import React from 'react';

// Monochrome icons (currentColor) for the About sheet's info rows and link list. Brand glyphs
// are the real Instagram / Facebook / Google marks drawn as single-colour shapes so they pick
// up the restaurant's accent colour instead of adding three brand colours to the page.
type P = { size?: number };
const line = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true as const,
});
const solid = (size: number) => ({ width: size, height: size, viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': true as const });

export const PinIcon = ({ size = 18 }: P) => (
  <svg {...line(size)}><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>
);
export const PhoneIcon = ({ size = 18 }: P) => (
  <svg {...line(size)}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" /></svg>
);
export const ClockIcon = ({ size = 18 }: P) => (
  <svg {...line(size)}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const GlobeIcon = ({ size = 18 }: P) => (
  <svg {...line(size)}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></svg>
);
export const ExternalIcon = ({ size = 16 }: P) => (
  <svg {...line(size)}><path d="M7 17L17 7M8.5 7H17v8.5" /></svg>
);
export const InstagramIcon = ({ size = 22 }: P) => (
  <svg {...line(size)}><rect x="3" y="3" width="18" height="18" rx="5.5" /><circle cx="12" cy="12" r="4" /><circle cx="17.3" cy="6.7" r=".9" fill="currentColor" stroke="none" /></svg>
);
export const FacebookIcon = ({ size = 22 }: P) => (
  <svg {...solid(size)}><path d="M13.5 21v-7.5h2.6l.5-3.1h-3.1V8.6c0-.9.3-1.5 1.6-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.1H8v3.1h2.5V21z" /></svg>
);
export const GoogleIcon = ({ size = 22 }: P) => (
  <svg {...solid(size)}><path d="M12.48 10.92v3.28h7.84c-.24 1.84-.85 3.19-1.79 4.13-1.15 1.15-2.93 2.4-6.05 2.4-4.83 0-8.6-3.89-8.6-8.72s3.77-8.72 8.6-8.72c2.6 0 4.51 1.03 5.91 2.35l2.31-2.31C18.75 1.44 16.13 0 12.48 0 5.87 0 .31 5.39.31 12s5.56 12 12.17 12c3.57 0 6.27-1.17 8.37-3.36 2.16-2.16 2.84-5.21 2.84-7.67 0-.76-.05-1.47-.17-2.05H12.48z" /></svg>
);
